// extracted by mini-css-extract-plugin
export var center = "HeadersWithDescription-module__center--3Dv77";
export var left = "HeadersWithDescription-module__left--2qfPg";
export var right = "HeadersWithDescription-module__right--lLo62";